import { recordErrorBoundarySpan } from './otelSetup';

export async function errorBoundaryHelper(error: Error, info: { componentStack: string }, trackingID: number, sessionID: number) {
  void trackingID;
  void sessionID;
  recordErrorBoundarySpan(error, info);
}
